import { render } from "./ConsulteGridColumnSelection.vue?vue&type=template&id=ea2345cc&ts=true"
import script from "./ConsulteGridColumnSelection.vue?vue&type=script&lang=ts"
export * from "./ConsulteGridColumnSelection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__